import { PayloadAction } from '@reduxjs/toolkit';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateSearch } from './state_search';

export const local_search_set_current = (payload: string): PayloadAction<string> => ({
  type: ENUM__redux_action.SEARCH_SET_CURRENT,
  payload: payload,
});

export const init_local_search_set_current = (state: StateSearch, action: PayloadAction<string>) => {
  if (action.payload == state.search_current._id) return;

  let search_id = action.payload;

  let search_settings: DTOSearchSettings | undefined = DTOSearchSettings.CREATE_STUB();

  if (search_id) {
    search_settings = state.search_history_map.get_or_assert(search_id, { context: 'search_settings' });
  }

  state.search_current = search_settings;
};
